import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { ShelfcaseService } from '../../../service/shelfcase/shelfcase.service';
import { LocaService } from '../../../service/loca/loca.service';
import { AbcService } from '../../../service/abc/abc.service';
import { LocaBlockService } from '../../../service/loca-block/loca-block.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9124',
  templateUrl: 'wa9124.component.html',
  styleUrls: ['wa9124.component.scss']
})
export class Wa9124Component implements OnInit {
  public componentTitle = 'WA9124:ロケマスタ什器単位登録';

  public abcs: any;
  public locablocks: any;
  public typecolds: any;
  public typestocks: any;
  public owners: any;
  public shelfcases: any;

  public whCd: FormControl;
  public floorCd: FormControl;
  public areaCd: FormControl;
  public lineCd: FormControl;
  public shelfCd: FormControl;
  public ownerId: FormControl;
  public shelfcaseId: FormControl;

  public selectedShelfcase: any;
  public layercountNr = 0;
  public ordercountNr = 0;

  public typecoldCd: FormControl;
  public typestockCd: FormControl;
  public locablockCd: FormControl;
  public locaabcId: FormControl;

  public notarriveFl = 0;
  public notshipFl = 0;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isLoginButtonEnabled = false;
  private isShelfCaseIdClassActive = false;
  private isOwnerIdClassActive = false;
  private isLocaBlockCdClassActive = false;
  private typestockCdCls = '';
  private typecodeCls = '';
  private locaAbcCls = '';

  @ViewChild('scrollContent')
  scrollContent :ElementRef;

  private whCdCls = '';
  private floorCdCls = '';
  private areaCdCls = '';
  private lineCdCls = '';
  private shelfCdCls = '';
  private isShowNumberError = false;

  constructor(
    private router: Router,
    private ownerService: OwnerService,
    private shelfcaseService: ShelfcaseService,
    private locaService: LocaService,
    private abcService: AbcService,
    private locaBlockService: LocaBlockService,
    private typeColdService: TypeColdService,
    private typeStockService: TypeStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    (this.whCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric2)])),
      (this.floorCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric1)])),
      (this.areaCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric3)])),
      (this.lineCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric1)])),
      (this.shelfCd = new FormControl('', [Validators.pattern(validation.alphaCapNumeric2)])),
      (this.shelfcaseId = new FormControl('', [Validators.required])),
      (this.ownerId = new FormControl('', [Validators.required])),
      (this.typestockCd = new FormControl('10', [Validators.required])),
      (this.typecoldCd = new FormControl('10', [Validators.required])),
      (this.locablockCd = new FormControl('1010', [Validators.required])),
      (this.locaabcId = new FormControl(0, [Validators.required])),
      (this.containerHeight = window.innerHeight - config.containerheaderMargin);
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;

    // TODO should be execute parallel, but API server don't work properly
    this.typeStockService
      .get()
      .then(outputJson => {
        //console.log(JSON.stringify(outputJson));
        this.typestocks = outputJson.typestocks;
        this.typeColdService
          .get()
          .then(_outputJson => {
            //console.log(JSON.stringify(_outputJson));
            this.typecolds = _outputJson.typecolds;
            this.locaBlockService
              .get()
              .then(__outputJson => {
                //console.log(JSON.stringify(__outputJson));
                this.locablocks = __outputJson.locablocks;
                this.abcService
                  .get()
                  .then(___outputJson => {
                    //console.log(JSON.stringify(___outputJson));
                    this.abcs = ___outputJson.abcs;
                    this.ownerService
                      .get()
                      .then(____outputJson => {
                        //console.log(JSON.stringify(____outputJson));
                        this.owners = ____outputJson.owners;
                        this.shelfcaseService
                          .get()
                          .then(______outputJson => {
                            this.working = false;
                            //console.log(JSON.stringify(______outputJson));
                            this.shelfcases = ______outputJson.shelfcases;
                          })
                          .catch(error => {
                            this.working = false;
                            this.errorInfo = this.commonService.getErrorMessage(error);
                          });
                      })
                      .catch(error => {
                        this.working = false;
                        this.errorInfo = this.commonService.getErrorMessage(error);
                      });
                  })
                  .catch(error => {
                    this.working = false;
                    this.errorInfo = this.commonService.getErrorMessage(error);
                  });
              })
              .catch(error => {
                this.working = false;
                this.errorInfo = this.commonService.getErrorMessage(error);
              });
          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';

    var whCd = this.whCd.value.trim();
    var floorCd = this.floorCd.value.trim();
    var areaCd = this.areaCd.value.trim();
    var lineCd = this.lineCd.value.trim();
    var shelfCd = this.shelfCd.value.trim();

    let errors = false;
    if (this.whCd.errors !== null) {
      this.whCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.floorCd.errors !== null) {
      this.floorCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.areaCd.errors !== null) {
      this.areaCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.lineCd.errors !== null) {
      this.lineCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shelfCd.errors !== null) {
      this.shelfCd.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shelfcaseId.errors !== null) {
      this.shelfcaseId.markAsTouched({ onlySelf: true });
      errors = true;
    }

    if (this.typestockCd.errors !== null) {
      this.typestockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typecoldCd.errors !== null) {
      this.typecoldCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locablockCd.errors !== null) {
      this.locablockCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.locaabcId.errors !== null) {
      this.locaabcId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.working = true;

    this.locaService
      .postLocashelf(
        whCd,
        floorCd,
        areaCd,
        lineCd,
        shelfCd,
        this.shelfcaseId.value,
        this.ownerId.value,
        this.typestockCd.value,
        this.typecoldCd.value,
        this.locablockCd.value,
        this.locaabcId.value,
        this.notarriveFl,
        this.notshipFl,
        'wa9124'
      )
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();

      setTimeout(()=>{
        this.scrollContent.nativeElement.scrollTop = 0;
      }, 200);
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.errorInfo = '';
    this.whCd.setValue('');
    this.floorCd.setValue('');
    this.areaCd.setValue('');
    this.lineCd.setValue('');
    this.shelfCd.setValue('');
    this.shelfcaseId.setValue('');
    this.ownerId.setValue('');
    this.typestockCd.setValue('10');
    this.typecoldCd.setValue('10');
    this.locablockCd.setValue('');
    this.locaabcId.setValue('0');

    this.isLoginButtonEnabled = false;

    this.whCdCls = '';
    this.floorCdCls = '';
    this.areaCdCls = '';
    this.lineCdCls = '';
    this.shelfCdCls = '';

    this.isShelfCaseIdClassActive = false;
    this.isOwnerIdClassActive = false;
    this.isLocaBlockCdClassActive = false;

    this.notarriveFl = 0;
    this.notshipFl = 0;
  }

  cancel() {
    this.closeButtonClick.emit(false);
  }

  onShelfCaseIdChanged() {
    this.isShelfCaseIdClassActive = this.shelfcaseId.value !== '';
    this.checkLoginButtonState();
  }

  onOwnerIdChanged() {
    this.isOwnerIdClassActive = this.ownerId.value !== '';
    this.checkLoginButtonState();
  }

  onLocaBlockCdChanged() {
    this.isLocaBlockCdClassActive = this.locablockCd.value !== '';
    this.checkLoginButtonState();
  }

  checkLoginButtonState() {
    this.isLoginButtonEnabled = this.whCdCls === 'active' &&
      this.floorCdCls === 'active' && this.areaCdCls === 'active' &&
      this.lineCdCls === 'active' && this.shelfCdCls === 'active' &&
      this.isShelfCaseIdClassActive && this.isOwnerIdClassActive &&
      this.isLocaBlockCdClassActive;
  }

  ngDoCheck() {
    if (!this.isShow)
      return;

    this.typestockCdCls = this.typestockCd.value !== '10' ? 'active' : 'normal';
    this.typecodeCls = this.typecoldCd.value !== '10' ? 'active' : 'normal';
    this.locaAbcCls = this.locaabcId.value !== '0' ? 'active' : 'normal';

    this.whCdCls = this.whCd.value === '' ? '' : 'active';
    this.floorCdCls = this.floorCd.value === '' ? '' : 'active';
    this.areaCdCls = this.areaCd.value === '' ? '' : 'active';
    this.lineCdCls = this.lineCd.value === '' ? '' : 'active';
    this.shelfCdCls = this.shelfCd.value === '' ? '' : 'active';
    this.isShowNumberError = false;

    if (this.whCdCls === 'active' && this.floorCdCls === 'active' &&
      this.areaCdCls === 'active' && this.lineCdCls === 'active' && this.shelfCdCls === 'active') {

        this.whCdCls = this.whCd.invalid ? 'error' : 'active';
        this.floorCdCls = this.floorCd.invalid ? 'error' : 'active';
        this.areaCdCls = this.areaCd.invalid ? 'error' : 'active';
        this.lineCdCls = this.lineCd.invalid ? 'error' : 'active';
        this.shelfCdCls = this.shelfCd.invalid ? 'error' : 'active';
        this.isShowNumberError = true;
      }

    this.checkLoginButtonState();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9124/wa9124.component.ts